<template>
    <div class="contacto">
            <div class="main col-lg-12">
                <h5 v-show="!logged" class="col-lg-12">Inicia sesión para tener acceso al los páneles <br>administrativos de la página</h5>
                <h5 v-show="logged" class="col-lg-12">Ya tienes una sesión iniciada.</h5>
                <div v-show="!logged" class="main-center">
                   <ValidationObserver ref="form">
                        <b-form id="form" class="form-container" @submit.prevent="onSubmit">
                        <div v-show="!logged" class="form-group">
                            <label for="userName">Usuario</label>
                            <ValidationProvider rules="required"  v-slot="{ errors }">
                                <b-form-input v-model="userData.userName" name="userName" class="form-control" type="text" placeholder="Nombre de Usuario"/>
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div v-show="!logged" class="form-group">
                            <label for="password">Contraseña</label>
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-input v-model="userData.password" name="password" type="password" placeholder="Contraseña"/>
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <b-button v-show="!loading && !logged" type="submit"  class=" col-lg-12 btnSend">Iniciar sesión</b-button>
                        
                        <b-button v-show="loading && !logged" class="col-lg-12 btnSend disabled"><b-spinner small class="mr-2"></b-spinner>Iniciando Sesión</b-button>
                    </b-form>
                    </ValidationObserver>
                    <img src="/static/images/aplicacion.png" class="mb-3"/>
                    <p class="google-terms">Este sitio está protegido por reCAPTCHA y Google, las
                      <a href = "https://policies.google.com/privacy"> Política de privacidad </a> y las
                      <a href = "https://policies.google.com/terms"> Condiciones del servicio </A> aplican.</p>
                </div><!--main-center"-->
                <b-button v-show="logged" @click="setLog(false)" class="btnClose">Cerrar sesión</b-button>
            </div><!--main-->
    </div>
</template>

<script>
import axios from "axios"
import authApi from "../api/auth";
import {ValidationProvider,ValidationObserver} from 'vee-validate';
import {mapState,mapActions} from "vuex";
import Notify from "@/plugins/notify";
import Swal from "sweetalert2";


export default {
  name: 'login',
  components: {
      ValidationProvider,
      ValidationObserver
  },
  data() {
      return {
        userData :{
            userName      : '',
            password      : ''
        },
        show            : true,
        loading:false
      }
    },
    computed: {
        ...mapState("menu",["principal"]),
        ...mapState("auth",["logged"])
    },
    watch: {
      logged(newValue, oldValue) {
        if(!newValue){
          this.logout();
        }
      }
    },
    methods: {
      ...mapActions("auth",["setLog"]),
      ...mapActions("menu",["setMenu"]),
      onSubmit(){
  
        this.$recaptcha("login").then(token => {this.Login();});

      },
  
    async Login(){
      var isValid = await this.$refs.form.validate();
      if (!isValid) {
        
      }else{
        this.loading = true;
        let formData = new FormData();
        
        formData.append("email",this.userData.userName);
        formData.append("password",this.userData.password);

        await authApi
          .login(formData)
          .then(response => {
            localStorage.setItem("user",response.data.user);
            localStorage.setItem("tokenAuth", response.data.access_token);
            localStorage.setItem("logged",true);
            this.setLog(true);
            axios.defaults.headers.common['Authorization'] = 'Bearer '+ response.data.access_token;
            this.reset();
            Notify.Success("¡Bienvenido!", response.data.user.name);
            this.$router.push("/home");
          }).catch(err => {
            if(err.response.status == 401){
              Notify.Error("Parece que algo sucedió.", "","Verifica tus credenciales y si el problema persiste, contacta con el administrador del sitio.");
            }else{
              Notify.Error("No eres tu, somos nostros.", "","Lo sentimos, en este momento no fue posible accesar a su cuenta, por favor, intentelo nuevamente.");
            }
          });
      
        this.loading = false;
      }
    },
    logout(){
        localStorage.removeItem("user");
        localStorage.removeItem("tokenAuth");
        localStorage.removeItem("logged");
        axios.defaults.headers.common['Authorization'] = 'Bearer '+ "";
        Notify.SuccessToast("¡Adios!");
        this.$router.push("/home");
    },
    reset() {

      this.$nextTick(() => {
          this.userData.userName = '';
          this.userDatapassword = '';

          this.$refs.form.reset();
        });
      },
    isMobile(){
      var check = false;
      //console.log(window.screen.width);
      if(window.screen.width < 769){
        return check=true;
      }
    },
    init(){
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera;

      this.setMenu(true);
    }
    },
    created () {
      this.init();
    },
}
</script>

<style scoped>
.google-terms{
     margin:15px;
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 15px;
    color: #828282;
}
img{
  width: 100%;
}
.error{
    font-family: Muli;
    font-style: normal;
    font-size: 12px;
    color:red;
}
    h5 {
        font-family: Muli;
        font-style: normal;
        font-size: 38px;
        line-height: 50px;
        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;
        color: #1E2144;

        margin: 100px 0px;
    }
    .btnDemo {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    display: block;
    margin-top: 30px;
    padding: 13px 27px;
  }

  .btnDemo:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }

  .btnSend {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #1E2245;
  border-radius: 100px;
    border-color: #1E2245 !important;
    color: #FFFFFF;
    margin-top: 30px;
    padding: 13px 27px;
  }

  .btnSend:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }

  .btnClose {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #1E2245;
    border-radius: 100px;
    border-color: #1E2245 !important;
    color: #FFFFFF;
    margin-top: 6%;
    margin-bottom: 6%;
    padding: 13px 27px;
  }

  .btnClose:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }

  .cliker-text{
      color:#2DB9D1;
  }

    .main{
        padding: 40px 0;
        background:  url("/static/images/bg_azul_categoria.svg") repeat-x;
    }
    .main input {
        font-size: 11px;
        padding-top: 3px;
        border: 1px solid #E0E0E0;
        border-radius: 5px;
    }
    .main-center{
        margin-top: 30px;
        margin-bottom: 120px !important;
        margin: 0 auto;
        max-width: 500px;
        padding: 10px 60px;
        background:#FFFFFF;
        text-shadow: none;
        -webkit-box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        -moz-box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        border-radius: 25px;
    }

    .form-container {
        padding: 50px 0px;
    }
  .form-group{
    margin-bottom: 30px;
  }
    .form-group > label {
        font-family: Muli-Light;
        font-style: normal;
        font-size: 14px;
        line-height: 10px;
        float:left;
        margin-left:20px;
        letter-spacing: 2px;
        color: #1E2144;
    }
   
    .placeholder {
        font-family: Muli-Light;
        font-style: normal;
        font-size: 14px;
        line-height: 30px;

        display: flex;
        align-items: center;

        color: #BDBDBD;
    }

    .help {
        margin-top: 50px;
    }

    span.input-group-addon i {
        color: #009edf;
        font-size: 17px;
    }

     @media(max-width: 768px){
          h5 {
        font-size: 24px;
        line-height: 35px;
        margin: 0px 0px;
    }

        .main-center{
      
        background: none;
        -webkit-box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        -moz-box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        }

.btnSend {
    width: 100%;
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    display: block;
    margin-top: 30px;
    padding: 13px 27px;
  }

  .btnSend:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }
        
     }
</style>